module.exports = __webpack_public_path__ + "img/Fliege.445e2c73.png";